<script>
  import Select from 'svelte-select';
  import FormTextarea from '../FormControls/FormTextarea.svelte';
  import FormInput from '../FormControls/FormInput.svelte';
  import { onDestroy } from 'svelte';
  import { searchKeyByValue } from 'components/Helper.js';

  export let form;
  export let errors;
  export let handleChange;
  export let units;
  export let selectedUnit;

  let countries = [];
  let stateCountryId = 0;
  let states = [];
  import { masterData, getMasterData } from '../../stores/masterData.js';
  import { text } from 'svelte/internal';
  const masterUnitUnsubscribe = masterData.subscribe((state) => {
    if (state != undefined) {
      countries = state.countries;
      states = state.states;
      stateCountryId = state.stateCountryId;
    }
  });
  onDestroy(() => {
    masterUnitUnsubscribe();
  });

  $: if ($form.addresses.length > 0) {
    for (const i in $form.addresses) {
      if ($form.addresses[i].countryLabel == undefined) {
        $form.addresses[i].countryLabel =
          $form.addresses[i].countryId > 0
            ? countries[searchKeyByValue(countries, 'id', $form.addresses[i].countryId)]
            : undefined;
      }
      if ($form.addresses[i].stateLabel == undefined) {
        $form.addresses[i].stateLabel =
          $form.addresses[i].stateId > 0
            ? states[searchKeyByValue(states, 'id', $form.addresses[i].stateId)]
            : undefined;
      }
    }
  }

  $: if ($form.unitId > 0) {
    if ($form.addresses.length == 0) {
      setTimeout(() => {
        addAddress();
      }, 400);
    }
  }

  const addAddress = () => {
    let oldAddresses = $form.addresses;
    let countryId = $form.unitId == 2 ? 234 : 235;

    let countryLabel =
      countryId > 0 ? countries[searchKeyByValue(countries, 'id', countryId)] : undefined;
    oldAddresses.push({
      street: '',
      city: '',
      state: '',
      zip: '',
      countryId: countryId,
      countryLabel: countryLabel,
      stateId: '',
      stateLabel: undefined,
    });
    $form.addresses = oldAddresses;
  };

  let objState;
</script>

<div class="p-3 h-100 font-size-12">
  <div class="profile-content mx-auto">
    <div class="block-title mb-4">
      <h3 class="mt-0 title"><span>General </span></h3>
    </div>
  </div>

  <div class="profile-content mx-auto h-100">
    <div class="row">
      <div class="col-md-6">
        <div class="form-group select-block mb-3">
          <label
            for=""
            class="form-label"
            >Business Unit
          </label>
          <Select
            isDisabled={true}
            bind:selectedValue={selectedUnit}
            showIndicator={true}
            isClearable={false}
            items={units}
            getSelectionLabel={(option) => {
              return option.name;
            }}
            optionIdentifier="id"
            getOptionLabel={(option) => {
              return option.name;
            }}
            placeholder="Select Business Unit"
          />
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group mb-3">
          <FormInput
            isRequired={true}
            name="name"
            label="Client Name"
            type="text"
            placeholder="Enter Client Name"
            error={$errors.name}
            bind:value={$form.name}
            autoFocus={true}
            handleChange={handleChange}
          />
        </div>
      </div>
    </div>

    <!-- <div class="row">
			<div class="col-md-12">
				<div class="form-group mb-3">
					<FormInput
						name="billingAddress"
						label="Billing Address"
						placeholder="Enter Biiling Address"
						error={$errors.billingAddress}
						bind:value={$form.billingAddress}
						{handleChange}
					/>
				</div>
			</div>
		</div> -->

    <div class="block-title mb-4">
      <h3 class="mt-0 title d-flex justify-content-between p-0">
        <span>Address</span>
        <button
          on:click={() => {
            addAddress();
          }}
          class="bg-transparent border-0 color-blue font-weight-500 mb-0 p-0"
          ><img
            class="icon-10"
            alt=""
            src="/images/plus.svg"
          /> Add New</button
        >
      </h3>
    </div>

    {#each $form.addresses as address, key}
      <div class="address-block">
        <div class="row">
          <div class="col-md-6">
            <FormInput
              name="addresses[{key}].street"
              label="Street"
              placeholder="Enter Street "
              error={$errors.addresses[key] != undefined
                ? $errors.addresses[key].street
                : undefined}
              bind:value={$form.addresses[key].street}
              handleChange={handleChange}
            />
          </div>

          <div class="col-md-6">
            <div class="form-group mb-3">
              <FormInput
                name="addresses[{key}].city"
                label="City"
                placeholder="Enter City "
                error={$errors.addresses[key] != undefined
                  ? $errors.addresses[key].city
                  : undefined}
                bind:value={$form.addresses[key].city}
                handleChange={handleChange}
              />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <div class="form-group select-block mb-3">
              {#if $form.addresses[key] != undefined && $form.addresses[key].countryId == stateCountryId}
                <label
                  for="addresses[{key}].countryId"
                  class="form-label undefined"
                  >State / Province
                </label>
                <Select
                  bind:this={objState}
                  bind:selectedValue={$form.addresses[key].stateLabel}
                  showChevron={true}
                  isClearable={false}
                  items={states}
                  getSelectionLabel={(option) => {
                    return option.name;
                  }}
                  on:select={(ev) => {
                    $form.addresses[key].stateId = ev.detail.id;
                  }}
                  optionIdentifier="id"
                  getOptionLabel={(option) => {
                    return option.name;
                  }}
                  placeholder="State / Province"
                />
              {:else}
                <FormInput
                  name="addresses[{key}].state"
                  label="State / Province"
                  placeholder="State / Province"
                  error={$errors.addresses[key] != undefined
                    ? $errors.addresses[key].state
                    : undefined}
                  bind:value={$form.addresses[key].state}
                  handleChange={handleChange}
                />
              {/if}
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group select-block mb-3">
              <label
                for="addresses[{key}].countryId"
                class="form-label undefined"
                >Country
              </label>
              <Select
                bind:selectedValue={$form.addresses[key].countryLabel}
                showChevron={true}
                isClearable={false}
                items={countries}
                getSelectionLabel={(option) => {
                  return option.name;
                }}
                on:select={(ev) => {
                  $form.addresses[key].countryId = ev.detail.id;

                  setTimeout(() => {
                    $form.addresses[key].state = '';
                    $form.addresses[key].stateId = '';
                    $form.addresses[key].stateLabel = undefined;
                  }, 300);
                }}
                optionIdentifier="id"
                getOptionLabel={(option) => {
                  return option.name;
                }}
                placeholder="Country"
              />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <div class="form-group mb-3">
              <FormInput
                name="addresses[{key}].zip"
                label="Zip / Postal Code"
                placeholder="Zip / Postal Code"
                error={$errors.addresses[key] != undefined ? $errors.addresses[key].zip : undefined}
                bind:value={$form.addresses[key].zip}
                handleChange={handleChange}
              />
            </div>
          </div>

          <div class="col-md-12">
            <div class="form-group mb-3">
              <div class="text-end">
                <button
                  class="btn btn-link px-0 mb-0 shadow-none border-0 font-size-12 color-red bg-transparent text-nowrap"
                  on:click={() => {
                    let oldAddresses = $form.addresses;
                    oldAddresses.splice(key, 1);
                    $form.addresses = oldAddresses;
                  }}
                >
                  <img
                    alt=""
                    class="icon-16 me-1"
                    src="/images/trash.svg"
                  /> Remove
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    {/each}
  </div>
</div>
